// 관세사 관리 (admin) — 관세사 마스터 CRUD + 업체↔관세사 매핑 (2026-05-28)
//   백엔드: routes/clearanceAgency.js (GET/POST/PUT/DELETE /clearance-agencies,
//           PATCH /companies/:id/clearance-agency) + GET /admin/companies (업체 전체)
//   매핑돼야 카톡공유/관세사 바로전송 시 해당 업체 면장 의뢰가 그 관세사 큐로 들어감.
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

var NAVY = '#1B3A5C';

function ClearanceAgencyAdmin({ showToast, user }) {
  var st = showToast || function () {};
  var agenciesState = useState([]); var agencies = agenciesState[0]; var setAgencies = agenciesState[1];
  var companiesState = useState([]); var companies = companiesState[0]; var setCompanies = companiesState[1];
  var searchState = useState(''); var search = searchState[0]; var setSearch = searchState[1];
  var formState = useState({ name: '', bizNo: '', ceo: '', tel: '', email: '' });
  var form = formState[0]; var setForm = formState[1];
  var credState = useState(null); var cred = credState[0]; var setCred = credState[1];

  function loadAgencies() {
    authFetch(API + '/clearance-agencies').then(function (r) { return r.json(); })
      .then(function (d) { if (Array.isArray(d)) setAgencies(d); }).catch(function () {});
  }
  function loadCompanies() {
    authFetch(API + '/admin/companies').then(function (r) { return r.json(); })
      .then(function (d) { setCompanies(Array.isArray(d) ? d : (d.companies || [])); }).catch(function () {});
  }
  useEffect(function () { loadAgencies(); loadCompanies(); }, []);

  function createAgency() {
    if (!form.name.trim()) { st('관세사명을 입력하세요', 'err'); return; }
    authFetch(API + '/clearance-agencies', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.success) { st('관세사 추가됨', ''); setForm({ name: '', bizNo: '', ceo: '', tel: '', email: '' }); loadAgencies(); }
        else st((d && d.error) || '추가 실패', 'err');
      }).catch(function () { st('추가 실패', 'err'); });
  }
  function toggleActive(a) {
    authFetch(API + '/clearance-agencies/' + a.id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ active: a.active ? 0 : 1 }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) loadAgencies(); else st((d && d.error) || '수정 실패', 'err'); }).catch(function () { st('수정 실패', 'err'); });
  }
  function issueAccount(a) {
    var reissue = !!a.accountUserId;
    var msg = reissue
      ? (a.name + ' 계정(' + a.accountUserId + ')의 비밀번호를 재발급할까요? 기존 비밀번호는 무효화됩니다.')
      : (a.name + ' 의 포탈 로그인 계정을 발급할까요?');
    if (!window.confirm(msg)) return;
    authFetch(API + '/clearance-agencies/' + a.id + '/account', { method: 'POST' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.success) { setCred({ name: a.name, userId: d.userId, tempPassword: d.tempPassword, reissued: d.reissued }); loadAgencies(); }
        else st((d && d.error) || '발급 실패', 'err');
      }).catch(function () { st('발급 실패', 'err'); });
  }
  function deleteAgency(a) {
    if (!window.confirm(a.name + ' 관세사를 삭제할까요? (처리 이력/매핑 있으면 불가)')) return;
    authFetch(API + '/clearance-agencies/' + a.id, { method: 'DELETE' })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) { st('삭제됨', ''); loadAgencies(); } else st((d && d.error) || '삭제 실패', 'err'); })
      .catch(function () { st('삭제 실패', 'err'); });
  }
  function setMapping(companyId, agencyId) {
    authFetch(API + '/companies/' + companyId + '/clearance-agency', { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ agencyId: agencyId || null }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.success) {
          st('매핑 저장됨', '');
          setCompanies(function (prev) { return prev.map(function (c) { return c.id === companyId ? Object.assign({}, c, { clearance_agency_id: agencyId || null }) : c; }); });
        } else st((d && d.error) || '매핑 실패', 'err');
      }).catch(function () { st('매핑 실패', 'err'); });
  }

  var activeAgencies = agencies.filter(function (a) { return a.active; });
  var filteredCompanies = companies.filter(function (c) {
    if (!search) return true;
    var q = search.toLowerCase();
    return (c.name || '').toLowerCase().indexOf(q) >= 0 || (c.bizNo || '').indexOf(q) >= 0;
  });
  var mappedCount = companies.filter(function (c) { return c.clearance_agency_id; }).length;

  return (
    <div style={{ padding: '20px 24px', maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ fontSize: 22, fontWeight: 800, color: NAVY, marginBottom: 4 }}>{'📦 관세사 관리'}</div>
      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 20 }}>{'관세사 등록 + 업체별 관세사 지정. 매핑된 업체의 인보이스 전송/카톡공유 시 해당 관세사에게 면장 의뢰가 갑니다.'}</div>

      <div style={{ display: 'grid', gridTemplateColumns: '420px 1fr', gap: 20 }}>
        {/* 관세사 마스터 */}
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
          <div style={{ padding: '14px 18px', borderBottom: '1px solid #e5e7eb', fontSize: 15, fontWeight: 700, color: NAVY }}>{'관세사 목록 (' + agencies.length + ')'}</div>
          <div style={{ padding: '14px 18px', borderBottom: '1px solid #f1f5f9', background: '#f8fafc' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginBottom: 6 }}>
              <input value={form.name} onChange={function (e) { setForm(Object.assign({}, form, { name: e.target.value })); }} placeholder="관세사명 *" style={inp} />
              <input value={form.bizNo} onChange={function (e) { setForm(Object.assign({}, form, { bizNo: e.target.value })); }} placeholder="사업자번호" style={inp} />
              <input value={form.ceo} onChange={function (e) { setForm(Object.assign({}, form, { ceo: e.target.value })); }} placeholder="대표자" style={inp} />
              <input value={form.tel} onChange={function (e) { setForm(Object.assign({}, form, { tel: e.target.value })); }} placeholder="연락처" style={inp} />
              <input value={form.email} onChange={function (e) { setForm(Object.assign({}, form, { email: e.target.value })); }} placeholder="이메일" style={Object.assign({ gridColumn: '1 / 3' }, inp)} />
            </div>
            <button onClick={createAgency} style={{ width: '100%', padding: '8px', background: NAVY, color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>{'+ 관세사 추가'}</button>
          </div>
          <div style={{ maxHeight: 'calc(100vh - 360px)', overflowY: 'auto' }}>
            {agencies.length === 0 && <div style={{ padding: 24, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>{'등록된 관세사 없음'}</div>}
            {agencies.map(function (a) {
              return (
                <div key={a.id} style={{ padding: '10px 18px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', opacity: a.active ? 1 : 0.5 }}>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 14, color: '#334155' }}>{a.name}{!a.active && <span style={{ fontSize: 11, color: '#94a3b8', marginLeft: 6 }}>{'(비활성)'}</span>}</div>
                    <div style={{ fontSize: 11, color: '#94a3b8' }}>{[a.tel, a.email].filter(Boolean).join(' · ') || '-'}</div>
                    <div style={{ fontSize: 11, marginTop: 2 }}>{a.accountUserId
                      ? <span style={{ color: '#0369a1', fontWeight: 700, fontFamily: 'monospace' }}>{'🔑 ' + a.accountUserId}</span>
                      : <span style={{ color: '#cbd5e1' }}>{'계정 미발급'}</span>}</div>
                  </div>
                  <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                    <button onClick={function () { issueAccount(a); }} style={Object.assign({ color: '#0369a1', borderColor: '#bae6fd', background: '#f0f9ff' }, miniBtn)}>{a.accountUserId ? '비번재발급' : '계정발급'}</button>
                    <button onClick={function () { toggleActive(a); }} style={miniBtn}>{a.active ? '비활성' : '활성'}</button>
                    <button onClick={function () { deleteAgency(a); }} style={Object.assign({ color: '#dc2626' }, miniBtn)}>{'삭제'}</button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* 업체 매핑 */}
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
          <div style={{ padding: '14px 18px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: 15, fontWeight: 700, color: NAVY }}>{'업체별 관세사 지정 (' + mappedCount + '/' + companies.length + ' 매핑됨)'}</span>
            <input value={search} onChange={function (e) { setSearch(e.target.value); }} placeholder="업체 검색..." style={Object.assign({ width: 200 }, inp)} />
          </div>
          <div style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#f8fafc', color: '#475569', position: 'sticky', top: 0 }}>
                  <th style={th}>{'업체명'}</th>
                  <th style={th}>{'사업자번호'}</th>
                  <th style={Object.assign({ width: 220 }, th)}>{'지정 관세사'}</th>
                </tr>
              </thead>
              <tbody>
                {filteredCompanies.length === 0 && <tr><td colSpan={3} style={{ padding: 24, textAlign: 'center', color: '#94a3b8' }}>{'업체 없음'}</td></tr>}
                {filteredCompanies.map(function (c) {
                  return (
                    <tr key={c.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                      <td style={Object.assign({ fontWeight: 600 }, td)}>{c.name}</td>
                      <td style={Object.assign({ color: '#64748b' }, td)}>{c.bizNo || '-'}</td>
                      <td style={td}>
                        <select value={c.clearance_agency_id || ''} onChange={function (e) { setMapping(c.id, e.target.value ? parseInt(e.target.value, 10) : null); }}
                          style={{ width: '100%', padding: '6px 8px', borderRadius: 6, border: '1px solid ' + (c.clearance_agency_id ? '#86efac' : '#d1d5db'), background: c.clearance_agency_id ? '#f0fdf4' : '#fff', fontSize: 12, cursor: 'pointer' }}>
                          <option value="">{'— 미지정 —'}</option>
                          {activeAgencies.map(function (a) { return <option key={a.id} value={a.id}>{a.name}</option>; })}
                        </select>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {cred && (
        <div onClick={function () { setCred(null); }} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div onClick={function (e) { e.stopPropagation(); }} style={{ background: '#fff', borderRadius: 12, padding: 24, width: 380, maxWidth: '90vw' }}>
            <div style={{ fontSize: 17, fontWeight: 800, color: NAVY, marginBottom: 4 }}>{cred.reissued ? '🔑 비밀번호 재발급됨' : '🔑 계정 발급됨'}</div>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 16 }}>{cred.name + ' — 아래 정보를 관세사에 전달하세요.'}</div>
            <div style={{ background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 8, padding: 14, marginBottom: 14 }}>
              <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 2 }}>{'아이디'}</div>
              <div style={{ fontSize: 16, fontWeight: 800, fontFamily: 'monospace', color: NAVY, marginBottom: 10 }}>{cred.userId}</div>
              <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 2 }}>{'임시 비밀번호'}</div>
              <div style={{ fontSize: 18, fontWeight: 800, fontFamily: 'monospace', color: '#dc2626', letterSpacing: 1 }}>{cred.tempPassword}</div>
            </div>
            <div style={{ fontSize: 12, color: '#b45309', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 6, padding: '8px 10px', marginBottom: 16 }}>{'⚠️ 비밀번호는 지금만 표시됩니다. 닫으면 다시 볼 수 없으니 즉시 전달하세요.'}</div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={function () { try { navigator.clipboard.writeText(cred.userId + ' / ' + cred.tempPassword); st('복사됨', ''); } catch (e) { st('복사 실패', 'err'); } }} style={{ flex: 1, padding: '9px 0', border: '1px solid #cbd5e1', background: '#f8fafc', color: '#475569', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>{'복사'}</button>
              <button onClick={function () { setCred(null); }} style={{ flex: 1, padding: '9px 0', background: NAVY, color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>{'닫기'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

var inp = { padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 12, outline: 'none', boxSizing: 'border-box' };
var miniBtn = { padding: '4px 10px', border: '1px solid #d1d5db', borderRadius: 6, background: '#fff', fontSize: 11, fontWeight: 600, cursor: 'pointer', color: '#475569' };
var th = { padding: '10px 14px', textAlign: 'left', fontWeight: 700, fontSize: 12, borderBottom: '2px solid ' + NAVY };
var td = { padding: '9px 14px', color: '#334155' };

export default ClearanceAgencyAdmin;
